import React, { useContext } from 'react';
import { FamilyContext } from '../../Context/FamilyHeadContext';
import { API_URL } from '../../services/apiService';
import {formatFullName} from "../../utils/personUtils";
import manPic from '../../Image/userM.png';
import womanPic from '../../Image/userW.png';
import {useTranslation} from "react-i18next";

const FamilyMemberCard = ({ person, onClick }) => {
    const { getAncestorPath } = useContext(FamilyContext);
    const isAncestor = getAncestorPath(person.gedId);
    const {t, i18n} = useTranslation()

    return (
        <div
            onClick={() => onClick?.(person.gedId)}
            className="group relative flex items-center gap-4 p-3 rounded-xl
        bg-white hover:bg-[#f8f5f1] transition-all duration-200
        border border-[#e6dfd4] hover:border-[#c9a66c]
        cursor-pointer shadow-[0_4px_20px_rgba(201,166,108,0.08)]
        hover:shadow-[0_4px_20px_rgba(201,166,108,0.16)]"
        >
            <div
                className="w-12 h-12 sm:w-14 sm:h-14 bg-white rounded-xl overflow-hidden flex-shrink-0 border-2 border-white shadow-sm">
                {person?.image ? (
                    <img
                        crossOrigin="use-credentials"
                        src={`${API_URL}/image/download/${encodeURIComponent(person.image)}`}
                        alt={`${formatFullName(person, i18n['language'])}`}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center">
                        <img
                            crossOrigin="use-credentials"
                            src={person.sex === 'M' ? manPic : womanPic}
                            alt={person.sex === 'M' ? "תמונת גבר" : "תמונת אישה"}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                        />
                    </div>
                )}
            </div>

            <div className="flex-grow min-w-0">
                <h3 className="text-sm sm:text-base font-medium text-[#4a3f30] font-heebo
          truncate group-hover:text-[#937c5d]">
                    {formatFullName(person, i18n['language'])}
                </h3>
            </div>
            {isAncestor && (
                <div className="hidden sm:block absolute top-2 left-2 text-xs
          font-medium text-[#937c5d] bg-[#f8f5f1] px-2 py-1 rounded-full font-heebo">
                    {t('AncestrySection.familyHead')}
                </div>
            )}
        </div>
    );
};

export default FamilyMemberCard;